import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { LocalidadeService } from '@app/shared/services';

import { environment } from '@environments/environment';

import { OrgaoEmissorRgService } from '@app/shared/services/orgao-emissor-rg.service';

import { Censo, ChaveValor, ConfigCamposFormulario, Loading } from '@app/shared/models';
import { UtilService } from '@app/shared/services/util.service';

@Component({
  selector: 'app-form-documentos',
  templateUrl: './form-documentos.component.html',
  styleUrls: ['./form-documentos.component.scss']
})
export class FormDocumentosComponent implements OnInit {

  @Input() formEtapa2: FormGroup;
  @Input() configCamposFormulario: ConfigCamposFormulario[];
  @Input() censo: Censo;

  cliente = environment.cliente;

  carregar = new Loading();
  estados: ChaveValor[] = [];
  orgaos: ChaveValor[] = [];

  constructor(
    private orgaoEmissorRgService: OrgaoEmissorRgService,
    private localidadeService: LocalidadeService,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.obterUfs();
    this.orgaoEmissorRgService.getOrgaoEmissorRG().subscribe((data) => this.orgaos = data);
  }

  obterUfs(): void {
    this.localidadeService.getEstados(this.carregar).subscribe(estados => this.estados = estados);
  }

  isRequired(campo: string): any {
    return this.utilService.isRequiredField(campo, this.formEtapa2)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    const isVisible = this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel
    return isVisible;
  }

  get verificarForm(): any {
    return this.utilService.verificarForm(this.formEtapa2);
  }
}
